import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { Extensions } from 'vscode/vscode/vs/workbench/common/contributions';
import { ViewsWelcomeContribution } from './viewsWelcomeContribution.js';
import { viewsWelcomeExtensionPointDescriptor } from './viewsWelcomeExtensionPoint.js';
import { ExtensionsRegistry } from 'vscode/vscode/vs/workbench/services/extensions/common/extensionsRegistry';

const extensionPoint = ExtensionsRegistry.registerExtensionPoint(viewsWelcomeExtensionPointDescriptor);
let WorkbenchConfigurationContribution = class WorkbenchConfigurationContribution {
    constructor(instantiationService) {
        instantiationService.createInstance(ViewsWelcomeContribution, extensionPoint);
    }
};
WorkbenchConfigurationContribution = ( __decorate([
    ( __param(0, IInstantiationService))
], WorkbenchConfigurationContribution));
( Registry.as(Extensions.Workbench))
    .registerWorkbenchContribution(WorkbenchConfigurationContribution, 3 );
